<ion-item [lines]="to['itemLines']">
  <ts-ion-form-field-label-ui
    [to]="to"
    *ngIf="to.label"
  ></ts-ion-form-field-label-ui>
  <ion-input
    [type]="isPasswordShown ? 'text' : 'password'"
    [formControl]="formControl"
    [ionFormlyAttributes]="field"
  ></ion-input>
</ion-item>
<ts-ion-form-field-validation-message-ui
  [field]="field"
  [showError]="showError"
></ts-ion-form-field-validation-message-ui>
<ion-item lines="none">
  <ion-label>
    <ng-container *transloco="let t; scope: 'sharedForm'">
      {{ t('sharedForm.password.show') }}
    </ng-container>
  </ion-label>
  <ion-checkbox slot="start" [(ngModel)]="isPasswordShown"></ion-checkbox>
</ion-item>
<ts-ion-form-field-help-ui [props]="to"></ts-ion-form-field-help-ui>
